import type { OrderSummary } from './order-summary'

export type OrdersPage = {
  count: number,
  page: number,
  items: OrderSummary[]
}
const buildOrdersPage = (count: number = 10, page: number = 0, items: OrderSummary[]): OrdersPage => ({
  count,
  page,
  items
})

export {
  buildOrdersPage
}



// WEBPACK FOOTER //
// ./src/types/orders-page.js